import { useLocation } from "react-router-dom";
import Header from "../../../../Components/Header";
import PurchaseForm from "./PurchaseForm";
import { Helmet } from "react-helmet";

const ViewGateEntry = () => {
  const location = useLocation();
  const { gate_id } = location.state || {}; 
  console.log(gate_id,"gate_id");
  

  return (
		<>
			<Helmet>
				<title>View Gate Entry</title>
			</Helmet>
			<Header />
			<div className="container-fluid maindiv pt-2">
				<PurchaseForm gateId={gate_id} />
			</div>
		</>
	);
};

export default ViewGateEntry;
